export const FLAT_TYPE_ID = 3;
